import { useRoute } from "vue-router";
import { useQuery } from '@vue/apollo-composable'
import { computed, watch, ref, onMounted } from "vue";
import { gqlMessagesCount } from "../../graphql/messages";
import { identifyPrimaryService } from "@/utils/corporateClients";
import { useStoreInboxUnreadStatus } from "@/stores/storeInboxUnreadStatus";

// props = 
// type: {
//   type: String,
//   required: false,
//   default: "SELF_SELECT"
// },
// clientInfo: {
//   type: Object,
//   required: false,
// },
// hasSelfSelectPortfolio: {
//   type: Boolean,
//   required: true,
//   default: false
// },
// corporateClientServices: {
//   type: Object,
//   required: true
// },
// killSwitchFlags: {
//   type: Object,
//   required: true
// }

const useNavigationLinks = (props) => {
  const route = useRoute();

  const storeInboxUnreadStatus = useStoreInboxUnreadStatus();
  
  const isCorporateClient = computed(function () {
    if (props.corporateClientServices?.services?.length) {
      const primaryService = identifyPrimaryService(props.corporateClientServices);
      if (primaryService && primaryService?.corporate) {
        return true
      }
    }
    return false
  });

  const links = ref([
    !props.killSwitchFlags.getDashboardDisabled ? {name: 'Dashboard', href: '/dashboard'} : null,
    {name: 'Market News', href: '/dashboard/market-news'},
    props.type === 'ADVISED' ? {name: 'AppChat', href: '/dashboard/appchat'} : null,
    props.type !== 'ADVISED' && !props.killSwitchFlags.getDashboardDisabled && props.hasPaymentAvailability ? {name: 'Add Money', href: '/dashboard/add-money'} : null,
    props.type !== 'ADVISED' ? {name: 'Bank Accounts', href: '/dashboard/bank-accounts'} : null,
    !props.killSwitchFlags.getDocumentsDisabled ? {name: 'Documents', href: '/dashboard/documents'} : null,
    {name: 'Support', href: '/dashboard/support'},
    {name: 'My Account', href: '/dashboard/my-account'},
    {
      name: !storeInboxUnreadStatus.getInboxHasUnreadMessages() ? 'Inbox' : undefined,
      html: !storeInboxUnreadStatus.getInboxHasUnreadMessages() ? undefined :
      `<div class="flex flex-row gap-4 justify-center items-center">
        Inbox 
        <span class="relative flex w-3 h-3" title="You have unread messages in your Inbox">
          <span class="absolute inline-flex h-full w-full animate-ping rounded-full bg-white text-xs opacity-75">&nbsp;</span>
          <span class="relative inline-flex w-2 h-2 top-0.5 left-0.5 rounded-full bg-sage text-xs">&nbsp;</span>
        </span>
      </div>`, 
      href: '/dashboard/messages',
    },
  ].filter(item => item != null));
  
  const refreshLinks = (selfSelectValue) => {
    links.value = determineLinks(selfSelectValue, storeInboxUnreadStatus.getInboxHasUnreadMessages());
    
    if (['INVESTED', 'FUNDED', 'WRAPPER_CREATED'].includes(props?.clientInfo?.status) || props?.clientInfo?.type === 'ADVISED') {
      const { onResult } = useQuery(gqlMessagesCount, {}, () => ({ fetchPolicy: 'no-cache' }));
    
      onResult((result) => {
        const hasUnreadMessages = result?.data?.clientInfo?.messageCounts?.unread > 0 && result?.data?.clientInfo?.messageCounts?.unread != null;
        storeInboxUnreadStatus.saveInboxHasUnreadMessages(hasUnreadMessages)
        links.value = determineLinks(selfSelectValue, hasUnreadMessages)
      })
    }
  };
  
  const determineLinks = (selfSelectValue, hasUnreadMessages = false) => {
    return [
      !props.killSwitchFlags.getDashboardDisabled ? {name: 'Dashboard', href: '/dashboard'} : null,
      {name: 'Market News', href: '/dashboard/market-news'},
      props.type === 'ADVISED' ? {name: 'AppChat', href: '/dashboard/appchat'} : null,
      props.type !== 'ADVISED' && !props.killSwitchFlags.getDashboardDisabled && props.hasPaymentAvailability ? {name: 'Add Money', href: '/dashboard/add-money'} : null,
      props.type !== 'ADVISED' ? {name: 'Bank Accounts', href: '/dashboard/bank-accounts'} : null,
      !props.killSwitchFlags.getDocumentsDisabled ? {name: 'Documents', href: '/dashboard/documents'} : null,
      {name: 'Support', href: '/dashboard/support'},
      {name: 'My Account', href: '/dashboard/my-account'},
      {
        name: !hasUnreadMessages ? 'Inbox' : undefined,
        html: !hasUnreadMessages ? undefined :
        `<div class="flex flex-row gap-4 justify-center items-center">
          Inbox 
          <span class="relative flex w-3 h-3" title="You have unread messages in your Inbox">
            <span class="absolute inline-flex h-full w-full animate-ping rounded-full bg-white text-xs opacity-75">&nbsp;</span>
            <span class="relative inline-flex w-2 h-2 top-0.5 left-0.5 rounded-full bg-sage text-xs">&nbsp;</span>
          </span>
        </div>`, 
        href: '/dashboard/messages',
      },
    ].filter(item => item != null);
  };
  
  
  watch(() => props.hasSelfSelectPortfolio, (selectSelectCreated) => { refreshLinks(selectSelectCreated, true); });
  watch(route, () => { refreshLinks(props?.hasSelfSelectPortfolio); });
  
  onMounted(() => { refreshLinks(props?.hasSelfSelectPortfolio) })

  return links;
}

export default useNavigationLinks;